import {
	GET_ACTIONS,
	FETCH_ACTION,
	UPDATE_ACTION,
	DELETE_ACTION,
	GET_ACTIONS_ANALYTICS,
	GET_ACTIONS_AT_RISK_SUMMARY,
} from "constants/actions";

const initialState = {
	actions: [],
	analytics: [],
	at_risk_summary: [],
	pageNumber: 1,
	pending: false,
	updated: false,
	created: [],
	queryParams: [],
};

export default function ActionActions(state = initialState, action) {
	switch (action.type) {
		case GET_ACTIONS:
			return {
				...state,
				actions: action.payload,
				pending: false,
				updated: false,
			};

		case FETCH_ACTION:
			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
			};

		case UPDATE_ACTION:
			// If exists, replace entry; otherwise append
			if (state.actions && Array.isArray(state.actions)) {
				const exists = state.actions.find((a) => a.id === action.payload.id);
				const actions = exists
					? state.actions.map((a) => (a.id === action.payload.id ? action.payload : a))
					: [...state.actions, action.payload];

				return {
					...state,
					actions,
					[action.payload.id]: action.payload,
					pending: false,
					updated: action.payload,
				};
			}

			return {
				...state,
				[action.payload.id]: action.payload,
				pending: false,
				updated: action.payload,
			};

		case DELETE_ACTION:
			return {
				...state,
				actions: (state.actions || []).filter((row) => row.id !== action.payload),
				pending: false,
				updated: true,
			};

		case GET_ACTIONS_ANALYTICS:
			return {
				...state,
				analytics: action.payload,
				pending: false,
			};

		case GET_ACTIONS_AT_RISK_SUMMARY:
			return {
				...state,
				at_risk_summary: action.payload,
				pending: false,
			};

		default:
			return state;
	}
}

